/*
 * Remember to add 
 * cordova plugin add cordova-plugin-chrome-apps-sockets-udp 
 * in index.html <script type="text/javascript" src="cordova.js"></script>
 */

//convert string to array buffer
function stringToArrayBuffer(string) {
    // UTF-8LE
    var buf = new ArrayBuffer(string.length * 2);
    var bufView = new Uint8Array(buf);
    for (var i = 0, strLen = string.length; i < strLen; i++) {
        bufView[i] = string.charCodeAt(i);
    }
    return buf;
}

//convert array buffer to string
function arrayBufferToString(buffer) {
    return String.fromCharCode.apply(null, new Uint8Array(buffer));
}

export function broadcastMessage(receiver) {
    // Kaiwei 20210204 Error "Address already in use" when broadcastMessage is called and socket already exists
    // Add a check to close all existing sockets before creating
    window.chrome.sockets.udp.getSockets((socketInfos: SocketInfo[]) => {
        if (socketInfos != null && socketInfos.length > 0) {
            let count_sockets = socketInfos.length;
            for (let socket_info of socketInfos) {
                count_sockets--;
                window.chrome.sockets.udp.close(socket_info.socketId, () => {
                    if (count_sockets == 0) {
                        //console.log('All udp sockets closed')
                        broadcast(receiver);
                    }
                })
            }
        } else {
            broadcast(receiver);
        }
    })
}

// Error "Address already in use" when broadcastMessage is called and socket already exists
// Add a check to close all existing sockets before creating
function broadcast(receiver) {
    //Create the socket
    window.chrome.sockets.udp.create({}, function (socketInfo) {
        // The socket is created, now we can send some data
        var socketId = socketInfo.socketId;

        var wholeString = '{"model": "all"}'; //data to send over

        window.chrome.sockets.udp.onReceive.addListener(function (info) {
            if (info.socketId !== socketId)
                return;

            //decode the ArrayBuffer into a string and use JSON.parse().
            var data_string = arrayBufferToString(info.data);
            var obj = JSON.parse(data_string);

            var model = obj['model']; //model
            var mac_addr = obj['macaddr']; //mac address
            var version = obj['version']; //version
            var ip = info.remoteAddress; //the address of the host the packet comes from
            var name = obj['name'];
            //var remotePort = info.remotePort; //the port of the host the packet comes from

            let controller_info = {
                model: model,
                version: version,
                ip_addr: ip,
                mac_addr: mac_addr,
                name: name,
            }

            receiver.rcvFoundController(controller_info)
        })

        //bind socket
        window.chrome.sockets.udp.bind(socketId, "0.0.0.0", 52001, function (result) {
            if (result < 0) {
                return;
            }

            window.chrome.sockets.udp.setBroadcast(socketId, true, function (result) {
                //console.log('udp socket setBroadcast');
            })

            window.chrome.sockets.udp.send(socketId, stringToArrayBuffer(wholeString), '255.255.255.255', 52000, function (sendInfo) {
                //console.log('broadcast sent: ' + sendInfo.bytesSent + 'bytes')
            });

            //set timeout, close socket
            setTimeout(function() { window.chrome.sockets.udp.close(socketId, () => {}); console.log('socket closed'); }, 5000);
        });
    });
}